import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref } from "vue";
import DiamondsDiamondDetails from "@/components/diamonds/diamondsDiamondDetails.vue";
import DiamondsSearch from "@/components/diamonds/diamondsSearch.vue";
import StepWidget from "@/components/stepWidget.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsMain',
  setup(__props) {

const certificatedDiamondData = ref(null);

const getDiamondId = () => {
  let path = window.location.pathname
  if (/\/diamonds\/search\//.test(path)) {
    return ""
  }
  if (/\/diamonds\/(.*)/.test(path)) {
    if (path.endsWith("/")) {
      path = path.substring(0, path.length - 1)
    }

    const parts = path.split('/')
    const lastPart = parts.pop() as string
    if (lastPart === 'diamonds' || lastPart === 'search') {
      return ""
    }
    return lastPart
  }
  return ""
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StepWidget, {
      show: true,
      onCertificatedDiamond: _cache[0] || (_cache[0] = (data) => certificatedDiamondData.value = data)
    }),
    (getDiamondId() !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DiamondsDiamondDetails, {
            "diamond-id": getDiamondId()
          }, null, 8, ["diamond-id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(DiamondsSearch, { "certificated-diamond": certificatedDiamondData.value }, null, 8, ["certificated-diamond"])
        ]))
  ]))
}
}

})